import { DocumentVisibility } from "@/types/resume";

export const visibilityItems = [
    { id: DocumentVisibility.PUBLIC, title: "Public" },
    { id: DocumentVisibility.PRIVATE, title: "Private" },
    { id: DocumentVisibility.UNLISTED, title: "Unlisted" },
];